export const EXTERNAL_COUNTRIES_ACTING = ['MX', 'CL', 'CO'];
export const LATAM_COUNTRIES = ['BR', 'MX', 'CL', 'CO'];
